/* jshint browserify: true */
'use strict';

import $ from 'jquery';
import widgetFactory from '../../widgetFactory';
import versionnedFile from 'Modules/versionnedFile';
import constants from '../../../Services/Code/Editors/Iframed/eventConstants';

const aceIframePackageUrl = '/legacy/js/ace-iframe.js';
const widgetName = 'aceEditor';
let widget;

widget = widgetFactory(widgetName, {
  options: {
    initialContent: '',
    language: 'text',
    inline: false,
  },

  _create: function () {
    this._super(widgetName);
    this.id = Math.round(Math.random() * Date.now());

    this.elements.$textarea = this.element;

    this.options.initialContent = this.options.initialContent
      ? this.options.initialContent
      : this.elements.$textarea.val().trim();

    this.elements.$textarea.val(this.options.initialContent);

    this.getMessageFromCodeEditorIframeHandler = this._onGetMessageFromCodeEditorIframe.bind(this);

    this._initIframe();
  },

  _destroy: function () {
    window.removeEventListener('message', this.getMessageFromCodeEditorIframeHandler, false);
  },

  _initIframe: function () {
    var $iframe = $('<iframe frameborder="0" src="about:blank" width="100%" height="300">'),
      script,
      doc,
      win,
      interval;

    $iframe.insertAfter(this.elements.$textarea);
    doc = $iframe.contents()[0];

    doc.open();
    doc.write('<!DOCTYPE html><html><body></body></html>');
    doc.close();

    win = $iframe[0].contentWindow;
    win.__id__ = this.id;

    script = doc.createElement('script');
    script.src = '//code.jquery.com/jquery-2.2.3.min.js';
    doc.body.appendChild(script);

    interval = setInterval(function () {
      if (win.$) {
        clearInterval(interval);

        script = doc.createElement('script');
        script.src = versionnedFile.getVersionned(aceIframePackageUrl);
        doc.body.appendChild(script);
      }
    }, 50);

    window.addEventListener('message', this.getMessageFromCodeEditorIframeHandler, false);

    this.elements.$iframe = $iframe;
    this.elements.$textarea.hide();
  },

  _sendMessageToCodeIframe: function (message) {
    var iframeWin = this.elements.$iframe[0].contentWindow;
    iframeWin.postMessage(JSON.stringify(message), '*');
  },

  _onGetMessageFromCodeEditorIframe: function (event) {
    var data, action;

    if (event.origin !== window.location.origin) {
      return;
    }

    try {
      data = JSON.parse(event.data);
    } catch (e) {
      /* */
    }

    if (!data || data.id !== this.id) {
      return;
    }

    action = data.action;

    switch (action) {
      case constants.EVENT_EDITOR_ON_READY:
        this._sendMessageToCodeIframe({
          inline: this.options.inline,
          action: constants.EVENT_EDITOR_INIT,
          code: this.options.initialContent,
          language: this.options.language,
        });

        this._trigger('onReady');
        break;

      case constants.EVENT_EDITOR_ESC:
        this._trigger('onEsc');
        break;

      case constants.EVENT_EDITOR_SUBMITTED:
        this._trigger('onSubmit');
        break;

      case constants.EVENT_EDITOR_CONTENT_CHANGED:
        this.elements.$textarea.val(data.content);
        this._trigger('onChange', { content: data.content });
        break;
    }
  },

  setInlineMode: function (state) {
    this.options.inlineMode = state;
    this._sendMessageToCodeIframe({
      action: constants.EVENT_EDITOR_SET_INLINE_MODE,
      inline: state,
    });
  },

  setLanguage: function (language) {
    this.options.language = language;
    this._sendMessageToCodeIframe({
      action: constants.EVENT_EDITOR_SET_LANGUAGE,
      language: language,
    });
  },

  getContent: function () {
    return this.elements.$textarea.val();
  },

  focus: function () {
    this._sendMessageToCodeIframe({
      action: constants.EVENT_EDITOR_FOCUS,
    });
  },
});

$.extend(widget, constants);

export default widget;
